import { useQuery, useQueryClient } from '@tanstack/react-query';
import { getProject } from '../../../services/projects/ProjectService';
import { ProjectResponse } from '../../../models/projects/ProjectResponse';
import { GET_PROJECT } from '../../query/project/keys';

export const useGetProject = (projectId: number | null) => {
  const queryClient = useQueryClient();
  const queryEnabled = !!projectId;

  const {
    data: project,
    isLoading,
    isError,
    error,
    refetch,
  } = useQuery<ProjectResponse>({
    queryKey: [GET_PROJECT, projectId],
    queryFn: () => getProject(projectId!),
    staleTime: 0,
    gcTime: 1000 * 60 * 5,
    refetchOnWindowFocus: false,
    refetchOnMount: true,
    enabled: queryEnabled,
  });

  return {
    project,
    isLoading: queryEnabled ? isLoading : false,
    isError: queryEnabled ? isError : false,
    error: queryEnabled ? error : null,
    refetch: async () => (!queryEnabled ? null : await refetch()),
    invalidate: () =>
      queryClient.invalidateQueries({
        queryKey: [GET_PROJECT, projectId],
        refetchType: 'active',
      }),
  };
};
